<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="70vw">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} FAQ
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-textarea
                  v-model="content.pergunta"
                  label="Pergunta*"
                  counter="300"
                  maxlength="300"
                  rows="1"
                  auto-grow
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 300), (v) => $min(v, 10)]"
                ></v-textarea>
                <v-textarea
                  v-model="content.resposta"
                  label="Resposta*"
                  counter="2000"
                  maxlength="2000"
                  dense
                  rows="3"
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 2000), (v) => $min(v, 10)]"
                ></v-textarea>
                <v-combobox
                  v-model="content.palavrasChave"
                  :items="[]"
                  chips
                  clearable
                  label="Palavras-Chave"
                  multiple
                  dense
                  persistent-hint
                  outlined
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      small
                      @click="select"
                      @click:close="remover(item)"
                    >
                      <strong>{{ item }}</strong>&nbsp;
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          actionText="Salvar"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Faq } from '~/commons/classes/faq';
import { DialogProps } from '~/commons/classes/dialog-props';
import ManterFaqService from '@/services/manter-faq.service';

export default {
  props: new DialogProps(Faq),
  mixins: [ManterFaqService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new Faq(this.content).format();
          return this.edit
            ? this.$editarFaq(this.content.id, payload)
            : this.$cadastrarFaq(payload);
        });
      };

      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    remover(palavraChave) {
      this.content.palavrasChave.splice(
        this.content.palavrasChave.indexOf(palavraChave),
        1
      );
    }
  }
}
</script>